import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import {styled} from "@mui/system";

import { buildSessionHealthIndicator } from "../../helpers/HealthIndicatorBuilder";
import { SESSION_HEALTH_STATUS } from "../../queries/GraphQLQueries";

const TooltipContainer = styled(Box)(({ loading = true }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.4rem',
  padding: '0.5rem',
  minWidth: '17rem',
  alignItems: loading ? 'center' : 'flex-start',
}));

export default function SessionHealthTooltip({session, options}) {
  const FLICKER_PREVENTING_LOADING_DELAY_IN_MILLISECONDS = 500;
  const [sessionHealthEvents, setSessionHealthEvents] = useState([]);
  const [isSessionHealthTooltipLoadingWithDelay, setIsSessionHealthTooltipLoadingWithDelay] = useState(false);
  const [fetchHealthStatus, {loading: isHealthStatusLoading, data}] = useLazyQuery(SESSION_HEALTH_STATUS,  { fetchPolicy: 'network-only' });

  useEffect(() => {
    if (session) {
      fetchHealthStatus({variables: {sessionId: session.id} });
    }
  }, [session, fetchHealthStatus]);

  useEffect(() => {
    if (!data?.sessionHealth) {
        return;
    }

    setSessionHealthEvents(data.sessionHealth);
}, [data]);

  useEffect(() => {
    if (isHealthStatusLoading) {
      setIsSessionHealthTooltipLoadingWithDelay(true);
    } else {
      const timer = setTimeout(() => {
        setIsSessionHealthTooltipLoadingWithDelay(false);
      }, FLICKER_PREVENTING_LOADING_DELAY_IN_MILLISECONDS);

      return () => clearTimeout(timer);
    }
  }, [isHealthStatusLoading]);

  return (
    <TooltipContainer loading={isSessionHealthTooltipLoadingWithDelay}>
      {isSessionHealthTooltipLoadingWithDelay && (
        <CircularProgress size={20} sx={{ color: 'white' }} />
      )}
      {!isSessionHealthTooltipLoadingWithDelay &&
        sessionHealthEvents.map((healthIndicator) =>
        buildSessionHealthIndicator(healthIndicator.key, healthIndicator.state, session, options)
      )}
    </TooltipContainer>
  );
}